(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-product-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ss-product-navigation')){
    customElements.define('ss-product-navigation',class extends HTMLElement{
      connectedCallback(){
        const section=document.getElementById('MainProduct-'+this.dataset.productSection);
        const target=section?.querySelector('.product__block--buy_buttons');
        if(!target)return;
        this.observer=new IntersectionObserver(entries=>{
          const entry=entries[0];
          this.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;
        },{threshold:0});
        this.observer.observe(target);
      }
      disconnectedCallback(){this.observer?.disconnect()}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
